@import "../../../../../shared/styles/base";

.CombinedHeader {
  padding: 2rem 0;
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;

  .Breadcrumbs {
    grid-row: 1 / span 1;
    grid-column: 1 / span 2;
    padding-bottom: 1.5rem;

    li {
      display: inline;

      &:not(:first-child)::before {
        content: "/";
        color: $ds-neutral-500;
        margin: 0 0.75rem;
      }
    }
  }

  .Title {
    grid-row: 2 / span 1;
    grid-column: 1 / span 1;

    &:focus-visible {
      outline: none;
    }
  }

  .Actions {
    grid-row: 2 / span 1;
    grid-column: 2 / span 1;
    text-align: right;
    justify-content: end;
  }
}

@media (max-width: $tablet) {
  .CombinedHeader {
    grid-template-columns: 100%;
    grid-template-rows: auto auto auto;

    .Breadcrumbs {
      grid-row: 1 / span 1;
      grid-column: 1 / span 1;
    }

    .Title {
      grid-row: 2 / span 1;
      grid-column: 1 / span 1;
    }

    .Actions {
      grid-row: 3 / span 1;
      grid-column: 1 / span 1;
    }
  }
}

@media (min-width: $tablet) {
  .CombinedHeader.hiddenTitle {
    display: flex;
    align-items: center;

    .Breadcrumbs {
      flex-grow: 1;
      padding-bottom: 0;
    }
  }
}
